
import React, { Component } from "react";
import Content from "../../../content/Content";
import secondaryBlueStyles from "../../../assets/css/modules/shared/buttons/secondary-blue-button.css";
// import primaryOrangeStyles from "../../../assets/css/modules/shared/buttons/primary-orange-button.css";
import secondaryOrangeStyles from "../../../assets/css/modules/shared/buttons/secondary-orange-button.css";
import primaryBlueStyles from "../../../assets/css/modules/shared/buttons/primary-blue-button.css";
import transversalStyles from "../../../assets/css/modules/shared/buttons/transversal-button.css";
import commonButtonStyles from "../../../assets/css/modules/shared/buttons/button.css";
import emailIcon from "../../../assets/img/email-icon.png";
import emailIconHol from "../../../assets/img/email-orange.png";
import contactIcon from "../../..//assets/img/contact-us/Contact-Icon.png";
import phoneIcon from "../../..//assets/img/contact-us/Phone-Icon.png";
import primarymfabluebuttonstyles from "../../../assets/css/modules/shared/buttons/primary-mfa-blue-button.css";

export default class ButtonMfa extends Component {  
  render() {
    let stylesList = ["btn"];
    let sizeStylesClass ;
    let styles ;

  
     styles = primarymfabluebuttonstyles.primaryMfaBlueButton;   
    sizeStylesClass = this.props.btntype === 'homeButton'? "primaryMfaBlueButton" : this.props.Healthsupportline1 === 'Healthsupportline' ? "primaryOrangeButtonSupport" : "primaryMfaBlueButton";
    if (this.props.buttonType === "secondaryBlueButton") {
      styles = secondaryBlueStyles.secondaryBlueButton;
      sizeStylesClass = this.props.btntype ==='homeButton'? "secondaryHomeBlueButton" : this.props.Healthsupportline1 === 'Healthsupportline' ? "secondaryBlueButtonSupport" : this.props.btntype === 'formButton'? "secondaryFormBlueButton": this.props.contactUs === 'contactUs' ? "secondaryBlueButtonContact" :"secondaryBlueButton";
    } else if (this.props.buttonType === "secondaryOrangeButton") {
      styles = secondaryOrangeStyles.secondaryOrangeButton;
      sizeStylesClass =  this.props.btntype ==='homeButton'? "secondaryHomeOrangeButton" : this.props.btntype === 'formButton'? "secondaryFormOrangeButton" : this.props.Healthsupportline1 === 'Healthsupportline' ? "secondaryOrangeButtonSupport":"secondaryOrangeButton";
    } else if (this.props.buttonType === "primaryBlueButton") {
      styles = primaryBlueStyles.primaryBlueButton;
      sizeStylesClass =  this.props.btntype ==='homeButton'? "primaryHomeBlueButton" : this.props.Healthsupportline1 === 'Healthsupportline' ? "primaryBlueButtonSupport": this.props.btntype === 'formButton'? "primaryFormBlueButton": this.props.contactUs === 'contactUs' ? "primaryBlueButtonContact"  :"primaryBlueButton";
    } else if (this.props.buttonType === "transversalButton") {
      styles = transversalStyles.transversalButton;
      sizeStylesClass = "transversalButton";
    }
  

    if (this.props.selected) {
      stylesList.push(commonButtonStyles.selected);
    }
    stylesList.push(styles);
    stylesList.push(sizeStylesClass);
    stylesList.push(commonButtonStyles.button);
    
      stylesList.push(commonButtonStyles.ssopanelbuttonMFA);
    
    if (this.props.disabled) {
      if(this.props.IsInternalView === true)      {
        stylesList.push(commonButtonStyles.disabled);
      }
      else if (this.props.IsCommValueDisabled === false || this.props.IsContactValueDisabled === false) {
        if (this.props.layout === "MOL") {
          stylesList.push(commonButtonStyles.commPrefValueDisabled);
        }
        else {
          stylesList.push(commonButtonStyles.commPrefValueHolDisabled);
        }
      }
    }
    if(this.props.startClaim === true){
      stylesList.push(commonButtonStyles.buttonSizeStartClaim);
    }
    return (
      <button
        id={this.props.id}
        name={this.props.name}
        type={this.props.type}
        className={stylesList.join(" ")}
        onClick={this.props.onClick}
        disabled={this.props.disabled}
        aria-label={this.props["aria-label"]}
      >
        <Content name={this.props.label} />
        {this.props.ClassName === "icon-email" && 
        <img src={emailIcon} alt={this.props.bgAlt}
              aria-hidden={this.props.bgAlt ? undefined : true} />}
               {this.props.ClassName === "icon-email-HOL" && 
        <img src={emailIconHol} alt={this.props.bgAlt}
              aria-hidden={this.props.bgAlt ? undefined : true} />}

        {this.props.ClassName === "icon-phone" &&  <i className="icon-phone" />}
        {this.props.ClassName === "icon-contact" &&   <img src={contactIcon} alt={this.props.bgAlt}
              aria-hidden={this.props.bgAlt ? undefined : true} />}
               {this.props.ClassName === "icon-phones" &&   <img src={phoneIcon} alt={this.props.bgAlt}
              aria-hidden={this.props.bgAlt ? undefined : true} />}
      </button>
    );
  }
}
